import { clearEmptyFields } from 'logic/validators/utils';
import {
  isRequiredValidator,
  isOfMinLength,
  isOfMaxLength,
  isNotLinkValidator,
} from 'logic/validators/validators';
import { FormErrors } from 'redux-form';

export const RATE_OFFER_FORM_NAME = 'rate-offer-form';

export type RateOfferFormValues = {
  reason?: string;
};

export enum RateOfferFormFields {
  reason = 'reason',
}

export type RateProblemFormValidationErrors = FormErrors<RateOfferFormValues, any>;

export const validateRateForm = (formValues: RateOfferFormValues, props: any) => {
  const { reason } = formValues;

  const errors: RateProblemFormValidationErrors = {
    reason:
      isRequiredValidator(reason) ||
      isOfMinLength(reason) ||
      isOfMaxLength(reason) ||
      isNotLinkValidator(reason),
  };

  return clearEmptyFields(errors);
};
